<script>
const hotelCostListReport = importVueComp('components/reports', 'HotelCostListReport', 'custom');
const imghotel = require('@/extra/custom/img/Htl_Verdes.png');
console.log(imghotel);

import Vue from 'vue';
let hotelColumn = Vue.component('hotel-column', {
    props: ['row', 'name'],
    template: `
        <div class="d-flex flex-column justify-content-center align-items-center" style="cursor:pointer" @click="showHotel">
            <span>{{hotelName}}</span>
            <img :src="imghotel" alt="Hotel" width="70" height="auto" class="mt-2" v-if="row.GreenLogo" />
        </div>
    `,
    methods: {
        async showHotel () {
            let h = await api.get('/api/hotel/' + this.row.HotelId);
            if (h) {
                this.$parent.$parent.hotel = h;
            }
        }
    },
    data () {
        return {
            imghotel: imghotel
        }
    },
    computed: {
        hotelName () {
            console.log(this.row);
            if (!this.row.HotelCategory) return this.row.HotelName;
            return `${this.row.HotelName} (${this.row.HotelCategory})`
        },
    }
})



export default {
    name: "custom-hotel-costlist-report",
    mixins: [hotelCostListReport],
    data() {
        return {
            componentFields: [
                {
                    name: 'HotelName',
                    component: hotelColumn
                }
            ],
            headerMesssage: {
                colspan: 8,
                html: false,
                rows: [
                    { text: "Rates per room, per night.", class: "white-space-nowrap" },
                    { text: "Not valid for National Holidays, Winter Holidays, Carnival, Easter, Christmas and New Year.", class: "white-space-nowrap"},
                    { text: "Please ask in each case the policies to be applied for each hotel.", class: "white-space-nowrap"},
                ]
            }
        };
    },
}
</script>
